'use strict';

/**
 * ACT-specific logic for web preview.
 *
 * NOTE: most of this logic should really be used in all OneCMS applications that want
 * web preview, but we're dependant on ACT-specific 'resource' handling and local storage
 * for now.
 */

angular.module('atex.art').factory('ArtPreviewService',
['$q', 'AuthenticationService', 'ContentService', 'WorkspaceService', 'PreviewService', 'ArtTemplateStore', 'ArtContentStore',

  function($q, AuthenticationService, ContentService, WorkspaceService, PreviewService, ArtTemplateStore, ArtContentStore) {
    var isActId = function(potentialActId) {
      return typeof potentialActId === 'string' && potentialActId.indexOf('act:') === 0;
    };

    var washContentId = function(id) {
      var washedId = id.replace(/contentid\//ig, '').replace(/externalid\//ig, '');

      return (washedId.indexOf(':') === -1) ? 'policy:' + washedId : washedId;
    };

    var getCookie = function(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length === 2) {
        return parts.pop().split(";").shift();
      }
      return undefined;
    };

    var setCookie = function(name, value) {
      document.cookie = name + '=' + value + ';path=/';
    };

    var setCookieIfNotAlreadySet = function(name, value) {
      if (typeof getCookie(name) === 'undefined') {
        setCookie(name, value);
      }
    };

    var calculatePreviewContextForParentChainFrom = function(contentId, contextArray) {
      // recursively follow the parent chain (insert -> security) until we reach 2.0, get permission denied or reach site root

      if (typeof contentId === 'undefined' || contentId.length === 0) {
        return $q.when(contextArray);
      }

      contentId = washContentId(contentId);

      if (contentId.indexOf('/') !== -1 && contentId.indexOf('policy:') === -1) {
        contentId = "policy:" + contentId.substring(contentId.lastIndexOf("/") + 1);
      }

      if (contentId.indexOf('2.0') !== -1) {
        return $q.when(contextArray);
      }

      return ContentService.getContent({ id: contentId }).then(function(responseInfo) {
        var type = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/_type');

        if (typeof type === 'undefined') {
          return $q.when(contextArray);
        }

        if (type === 'p.siteengine.SiteRoot') {
          return $q.when(contextArray);
        }

        var insertParent = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/p.InsertionInfo/data/insertParentId');
        var securityParent = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/p.InsertionInfo/data/securityParentId');

        var parentToFollow = insertParent || securityParent;

        if (typeof parentToFollow === 'undefined') {
          return $q.when(contextArray);
        }

        contextArray.unshift(contentId);

        return calculatePreviewContextForParentChainFrom(parentToFollow, contextArray);
      }).then(undefined, function(error) {
        if (error.type === atex.onecms.error.types.PERMISSION_DENIED) {
          return contextArray;
        }

        return $q.reject(error);
      });
    };

    var workSpaceMap = {};

    var storeToWorkspace = function(content, workspaceName) {
      var contentId = content.meta.id.replace(/contentid\//ig, '').replace(/externalid\//ig, '');
      var isActResource = typeof content.meta !== 'undefined' && isActId(content.meta.id);

      var processWorkspaceResult = function(workspaceResult) {
        var resourceId = workspaceResult.id;

        return WorkspaceService.getContent({ id: resourceId, workspace: workspaceName }).then(function(responseInfo) {
          var realId = responseInfo.data.aspects.contentData.version;
          var storedContentId = 'contentid/' + realId.substring(0, realId.lastIndexOf(':'));
          return { id: storedContentId, useWorkspace: true };
        });
      };

      if (isActResource || content.local.existsOnServer === false) {
        // Always create...

        return WorkspaceService.createContent({
          workspace: workspaceName,
          data: angular.fromJson(angular.toJson(_.extend({}, content.data)))
        }).then(processWorkspaceResult);
      } else {
        // Update if modified...

        if (typeof content.local !== 'undefined' && content.local.persisted !== true && typeof workSpaceMap[contentId] === 'undefined' ) {

          workSpaceMap[contentId] = true;

          return WorkspaceService.updateContent({
            id: washContentId(contentId),

            workspace: workspaceName,
            data: angular.fromJson(angular.toJson(_.extend({}, content.data)))
          }).then(processWorkspaceResult);
        }
      }

      return $q.when({ id: 'contentid/' + content.meta.id, useWorkspace: false });
    };

    var storeContent = function(content, workspaceName, resourceData, useWorkspace, storedContents) {
      return ArtTemplateStore.getTemplateFor(content).then(function(template) {
        var additionalPromises = [];

        if (template !== undefined){
          var fields = template.dataBindings;

          for (var j = 0; j < fields.length; j++) {
            var field = fields[j];

            if (field.widget === 'pResourceArea') {
              var shortPath = field.path || field.domainObjects.data;
              var path = atex.onecms.ObjectUtils.expandShortPath(shortPath);

              var fieldData = atex.onecms.ObjectUtils.getByPath(content.data.aspects, path);

              for (var i = 0; i < fieldData.length; i++) {
                (function (fieldData, i) {
                  var resource = fieldData[i];

                  var storedResourceContentId = resource.replace(/contentid\//ig, '').replace(/externalid\//ig, '');

                  if (!isActId(storedResourceContentId)) {
                    storedResourceContentId = (atex.onecms.OneCMSUtils.isNewContentId(storedResourceContentId)) ? storedResourceContentId : 'policy:' + storedResourceContentId;
                  }

                  // Keep track of already worked contents (to avoid recursive) [max]
                  if (storedContents && storedContents.constructor === Array) {
                    if (storedContents.indexOf(storedResourceContentId) >= 0) {
                      return $q.when({useWorkspace: useWorkspace});
                    }
                    storedContents.push(storedResourceContentId);
                  }

                  var promise = ArtContentStore.hasLocallyStored(storedResourceContentId).then(function (stored) {
                    if (stored === true) {
                      return ArtContentStore.getById(storedResourceContentId).then(function (subContent) {
                        return storeContent(subContent, workspaceName, resourceData, false, storedContents);
                      }).then(function (storeContentResult) {
                        var contentId = storeContentResult.id;

                        if (typeof resourceData !== 'undefined') {
                          resourceData.push({actId: fieldData[i], contentId: washContentId(contentId)});
                        }
                        fieldData[i] = contentId;

                        return storeContentResult;
                      });
                    }

                    return $q.when({useWorkspace: useWorkspace});
                  });

                  additionalPromises.push(promise);
                })(fieldData, i);
              }
            }
          }
        }

        return $q.all(additionalPromises);
      }).then(function(results) {
        useWorkspace = useWorkspace || _.any(results, function(result) { return result.useWorkspace === true; });

        return storeToWorkspace(content, workspaceName).then(function(workspaceResult) {
          return { id: workspaceResult.id, useWorkspace: useWorkspace || workspaceResult.useWorkspace };
        });
      });
    };

    return {
      calculatePreviewContext: function(topDomainObject) {
        var associatedSitesDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/p.InsertionInfo/data/associatedSites');
        var insertParentDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/p.InsertionInfo/data/insertParentId');
        var securityParentDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/p.InsertionInfo/data/securityParentId');

        var insertParentId = (typeof insertParentDomainObject !== 'undefined') ? insertParentDomainObject.getData() : undefined;
        var securityParentId = (typeof securityParentDomainObject !== 'undefined') ? securityParentDomainObject.getData() : undefined;
        var associatedSites = (typeof associatedSitesDomainObject !== 'undefined') ? associatedSitesDomainObject.getData() : [];

        return calculatePreviewContextForParentChainFrom(insertParentId, []).then(function(contexts) {
          if (contexts.length === 0) {
            return calculatePreviewContextForParentChainFrom(securityParentId, []);
          }

          return contexts;
        }).then(function(contexts) {
          var calculatedContexts = contexts;

          if (contexts.length === 0) {
            if (typeof associatedSites !== 'undefined' && associatedSites.length > 0) {
              calculatedContexts = [washContentId(associatedSites[0])];
            }
          }

          return calculatedContexts;
        });
      },

      preparePreview: function(channel, article, data, topDomainObject, mode) {
        var articleData = topDomainObject.pack();

        delete articleData.operations;

        var newArticle = atex.Content(JSON.parse(JSON.stringify(articleData)),
                                      JSON.parse(JSON.stringify(article.meta)),
                                      JSON.parse(JSON.stringify(article.local)));

        var resourceData = data.resourceData || undefined;

        workSpaceMap = {};

        return AuthenticationService.getCurrentUser().then(function(currentUser) {
          var workspaceName = channel + 'preview-' + btoa(currentUser.token);

          return WorkspaceService.clearWorkspace({ workspace: workspaceName }).then(function() {
            // Pass last parameter storedContents array to keep track of already worked contents and avoid recursive [max]
            return storeContent(newArticle, workspaceName, resourceData, false, []);
          }).then(function(contentStoreResult) {
            var useWorkspace = contentStoreResult.useWorkspace;
            data.mode = mode || channel;
            var previewInfo = {
              id: contentStoreResult.id,
              channel: channel,

              data: data
            };

            if (useWorkspace === true) {
              previewInfo.workspace = workspaceName;
            }

            return PreviewService.preview(previewInfo);
          }).then(function(result) {
            if ( typeof result.data.previewUrl !== 'undefined' ) {
              var url = result.data.previewUrl;
              var paramName = 'contentIdsInEdit';
              var idx = url.indexOf(paramName + '=');
              if (idx > 0) {
                var endIdx = url.indexOf('&', idx);
                if (endIdx < 0) {
                  endIdx = url.length;
                }
                var contentId = url.substring(idx + paramName.length + 1, endIdx);
                var userId = currentUser.principalId;
                var sessionKey = currentUser.token.replace(userId + '::', '');

                setCookie('polopoly.' + paramName, contentId);
                setCookieIfNotAlreadySet('sessionKey', sessionKey);
                setCookieIfNotAlreadySet('userId', userId);
              }
            }
            return result;
          });
        });
      },

      openPreview: function(previewResult_or_url, articleId) {
        var url = (previewResult_or_url.data) ? previewResult_or_url.data.previewUrl : previewResult_or_url;
        return window.open(url, 'ACT web preview - ' + articleId);
      }
    };
  }
]);
